import Link from 'next/link';

import { Plain } from '@/components/UI/RoofCheck';
import { ToTop } from '@/components/UI/ToTop';

import { Content } from '@/components/Default/Content';
import { Image } from '@/components/Default/Image';

const Footer = () => {
    return (
        <footer className='relative text-gray-300 px-0 py-0 md:px-8 md:py-5'>
            <ToTop className='absolute top-0 right-0 mt-5 mr-8 sm:mr-16' />
            <div className='bg-black rounded-none md:rounded-3xl'>
                <div className='flex flex-col xl:flex-row gap-x-16 w-full max-w-screen-4xl px-8 sm:px-16 py-8 mx-auto'>
                    <div className='text-center xl:text-left text-lg md:text-xl w-full xl:max-w-sm flex flex-col justify-center leading-8'>
                        <Image src='https://timeforsolar-assets.s3.eu-west-2.amazonaws.com/logo-letterform-05.svg' width={275} height={0} alt='' className='shrink-0 mx-auto w-40 h-40 lg:w-60 lg:h-60 xl:w-auto md:h-auto' />
                        <Content>
                            Wil jij ook <span className='underline'>binnen 30 dagen</span> zonnepanelen?
                        </Content>
                        <Content>
                            Doe dan de gratis dakcheck en zie direct wat je zult besparen!
                        </Content>
                    </div>
                    <div className='flex flex-col 2xl:flex-row flex-grow items-start justify-between md:px-0 lg:px-24 xl:px-0'>
                        <div className='flex flex-col sm:flex-row gap-8 pt-16 sm:pt-28 sm:pb-28 text-lg'>
                            <div>
                                <h2 className='text-lg sm:text-2xl text-primary-500 font-semibold mb-4'>
                                    Bedrijf
                                </h2>
                                <div className='text-base sm:text-lg space-y-2'>
                                    <div className='flex gap-4'>
                                        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-6 h-6 shrink-0'>
                                            <path strokeLinecap='round' strokeLinejoin='round' d='M15 10.5a3 3 0 11-6 0 3 3 0 016 0z' />
                                            <path strokeLinecap='round' strokeLinejoin='round' d='M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z' />
                                        </svg>

                                        <div className='space-y-2'>
                                            <div>Buitendijks 17</div>
                                            <div>3356 LX, Papendrecht</div>
                                            <div>Zuid-Holland, Nederland</div>
                                        </div>
                                    </div>
                                    <div className='flex gap-4'>
                                        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-6 h-6 shrink-0'>
                                            <path strokeLinecap='round' strokeLinejoin='round' d='M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z' />
                                        </svg>

                                        <Link href='tel:+31 6 40048389' className='hover:underline'>
                                            +31 6 40048389
                                        </Link>
                                    </div>
                                    <div className='flex gap-4'>
                                        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-6 h-6 shrink-0'>
                                            <path strokeLinecap='round' d='M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25' />
                                        </svg>

                                        <Link href='mailto:info@timeforsolar.nl' className='hover:underline'>
                                            info@timeforsolar.nl
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <h2 className='text-lg sm:text-2xl text-primary-500 font-semibold mb-4'>
                                    Help & ondersteuning
                                </h2>
                                <ol className='text-base sm:text-lg'>
                                    <li>
                                        <Link href='/contact' className='hover:underline'>Contact</Link>
                                    </li>
                                    <li>
                                        <Link href='/contact' className='hover:underline'>Probleem melden</Link>
                                    </li>
                                </ol>
                            </div>

                            <div>
                                <h2 className='text-lg sm:text-2xl text-primary-500 font-semibold mb-4'>
                                    Handige links
                                </h2>
                                <ol className='text-base sm:text-lg'>
                                    <li>
                                        <Link href='/diensten/groepenkast-vervangen' className='hover:underline'>Groepenkasten</Link>
                                    </li>
                                    <li>
                                        <Link href='/producten/zonnepanelen' className='hover:underline'>Zonnepanelen</Link>
                                    </li>
                                    <li>
                                        <Link href='/diensten/laadpaal-installeren' className='hover:underline'>Laadpalen</Link>
                                    </li>
                                    <li>
                                        <Link href='/producten/airco' className='hover:underline'>Airconditioning</Link>
                                    </li>
                                    <li>
                                        <Link href='/service' className='hover:underline'>Service Pakket</Link>
                                    </li>
                                    <li>
                                        <Link href='/diensten/storingsdienst' className='hover:underline'>Storingsdienst</Link>
                                    </li>
                                </ol>
                            </div>
                        </div>
                        <div className='flex flex-col w-full max-w-full 2xl:max-w-lg py-8'>
                            <Plain />

                            <div id='trustbox' className='trustpilot-widget pb-8' data-locale='nl-NL' data-template-id='5419b6a8b0d04a076446a9ad' data-businessunit-id='64df61b03b16fa082dac6d65' data-style-height='24px' data-style-width='100%' data-theme='dark' data-min-review-count='10' data-style-alignment='center'>
                                <a href='https://nl.trustpilot.com/review/timeforsolar.nl' target='_blank' rel='noopener' />
                            </div>

                            <div className='flex justify-center gap-x-4'>
                                <Link href='https://www.facebook.com/timeforsolar.nl' target='_blank'>
                                    <Image src='/assets/share/facebook.svg' width={24} height={24} alt='Facebook' className='invert' />
                                </Link>
                                <Link href='https://www.instagram.com/timeforsolar.nl' target='_blank'>
                                    <Image src='/assets/share/instagram.svg' width={24} height={24} alt='Instagram' className='invert' />
                                </Link>
                                <Link href='https://www.twitter.com/timeforsolar_nl' target='_blank'>
                                    <Image src='/assets/share/x.svg' width={24} height={24} alt='X (Twitter)' className='invert' />
                                </Link>
                                <Link href='https://www.linkedin.com/company/time-for-solar' target='_blank'>
                                    <Image src='/assets/share/linkedin.svg' width={24} height={24} alt='LinkedIn' className='invert' />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-full max-w-screen-4xl flex flex-col-reverse md:flex-row text-center items-center md:justify-between gap-y-4 md:gap-x-2 py-12 px-4 sm:px-16 mx-auto border-t border-neutral-900'>
                    <div>
                        Copyright © 2022-2025 Time for Solar. Alle rechten voorbehouden.
                    </div>
                    <ol className='flex gap-x-2'>
                        <li>
                            <Link href='/algemene-voorwaarden' className='hover:underline'>Algemene voorwaarden</Link>
                        </li>
                        <li>
                            <Link href='/privacy-beleid' className='hover:underline'>Privacy beleid</Link>
                        </li>
                    </ol>
                </div>
            </div>
        </footer>
    );
};

export { Footer };